<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            :actions="actions"
            ajax-path="unifi/sites"
        />
        <app-modal
            :show.sync="showDevicesModal"
            width="lg:w-5/6"
            custom-class="flex flex-col h-full"
        >
            <template slot="header">{{ selected.desc }} Devices</template>
            <template slot="body">
                <devices :site="selected.name"/>
            </template>
        </app-modal>
        <app-modal
            :show.sync="showClientsModal"
            width="lg:w-5/6"
            custom-class="flex flex-col h-full"
        >
            <template slot="header">{{ selected.desc }} Clients</template>
            <template slot="body">
                <clients :site="selected.name"/>
            </template>
        </app-modal>
    </div>
</template>

<script>
    import Devices from '@/views/unifi/Devices.vue';
    import Clients from '@/views/unifi/Clients.vue';

    export default {
        components: {
            Devices,
            Clients,
        },
        data() {
            return {
                showDevicesModal: false,
                showClientsModal: false,
                selected: {},
                columns: [
                    {
                        title: 'Name',
                        field: 'name',
                        sorter: 'string',
                        minWidth: 150,
                    },
                    {
                        title: 'Description',
                        field: 'desc',
                        sorter: 'string',
                        minWidth: 150,
                    }
                ],
                actions: [
                    {
                        label: 'Devices',
                        icon: () => import('@/icons/DevicesOtherOutlined.vue'),
                        handler: (data) => {
                            this.selected = data[0];
                            this.showDevicesModal = true;
                        }
                    },
                    {
                        label: 'Clients',
                        icon: () => import('@/icons/PeopleOutlined.vue'),
                        handler: (data) => {
                            this.selected = data[0];
                            this.showClientsModal = true;
                        }
                    }
                ],
            }
        }
    }
</script>